import { Auth, ProgressBar } from "@spendlevel/shared-login-frontend";
import { FormEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function UpdatePassword() {
    const [errorMsgHidden, setErrorMsgHidden] = useState('none');
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const location = useLocation();
    let navigate = useNavigate();

    const handleUpdatePassword = async (event: FormEvent) => {
        event.preventDefault();

        setShowProgressBar(true);

        const result = await Auth.updatePassword(location.state.email, (document.getElementById('temporaryPassword') as HTMLInputElement).value);

        setShowProgressBar(false);

        switch (result?.status) {
            case 'Failed':
                setErrorMsg(result.error?.message);
                setErrorMsgHidden('contents');
                break;
            case 'MFA':
                navigate('/mfa', {state: {isMfa: true}});
                break;
            case 'MFASetup':
                navigate('/mfasetup', {state: {mfaSetupUrl: result.mfaSetupUrl}});
                break;
        }
    };

    return (
        <>
            {showProgressBar && <ProgressBar/>}
            <div>
                <input type="password" id="temporaryPassword" className="form-control" placeholder="Enter temporary password" />
            </div>
            <div>
                <span style={{textAlign: 'center', display: errorMsgHidden}}>
                <div className="alert alert-danger" style={{border: '1px solid #ff9d9a', fontWeight: '400 !important'}}>{errorMsg}</div>
                </span>
            </div>
            <div>
                <button className="btn btn-primary" title="Update password" onClick={handleUpdatePassword}>Update Password</button>
            </div>
        </>
    );
}

export default UpdatePassword;
